import BackButtonRow from "../../../Common/DetailsForm/Fragments/BackButtonRow";

import { httpGet } from "../../../Common/Http/httpGet";
import LoadingContentWrapper from "../../../Common/Loading/LoadingContentWrapper";
import { useEffect, useState } from "react";
import { EInvoiceConsentLogEntryVM } from "./eInvoiceConsentLogEntryVM";
import HistoryPresenter from "./HistoryPresenter";

export default function History(props: {
  navigate: (url: string) => void;
  backUrl?: string;
}) {
  let backUrl = props.backUrl || "../index";

  const [dataObject, setDataObject] =
    useState<EInvoiceConsentLogEntryVM[] | undefined>(undefined);

  useEffect(() => {
    const setData = async () => {
      setDataObject(undefined);
      let a = await httpGet<EInvoiceConsentLogEntryVM[]>("/api/Consent/EInvoiceConsent/GetLog");
      setDataObject(a);
    };

    setData();
  }, []);

  return (
    <>
      <h1 className="border-bottom pb-2 mt-4 mb-4">Historia zmian</h1>
      <LoadingContentWrapper isLoading={!dataObject}>
        {!!dataObject && (
          <>
            <HistoryPresenter object={dataObject!}></HistoryPresenter>
            <BackButtonRow
              onClick={() => {
                props.navigate(backUrl);
              }}
            />
          </>
        )}
      </LoadingContentWrapper>
    </>
  );
}
